(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8c83"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8c83"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bB0zn", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $8713978b2328d32b$export$71511d61b312f219; });
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("6QEWP", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $4fc75ccb937ab1df$export$71511d61b312f219; });
function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("kB67t", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $efec029548ccee7f$export$71511d61b312f219; });

var $Q9cvz = parcelRequire("Q9cvz");

var $c4AWK = parcelRequire("c4AWK");

var $dNApw = parcelRequire("dNApw");

var $ihB7G = parcelRequire("ihB7G");
function $efec029548ccee7f$export$71511d61b312f219(arr, i) {
    return (0, $Q9cvz._)(arr) || (0, $c4AWK._)(arr, i) || (0, $ihB7G._)(arr, i) || (0, $dNApw._)();
}

});
parcelRegister("Q9cvz", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $09cbfe85151ea6c6$export$71511d61b312f219; });
function $09cbfe85151ea6c6$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("c4AWK", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $8ca2848f896a6803$export$71511d61b312f219; });
function $8ca2848f896a6803$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("dNApw", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a0bc1859061deae1$export$71511d61b312f219; });
function $a0bc1859061deae1$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("ihB7G", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d4f69c5c6c4654b1$export$71511d61b312f219; });

var $gNF1f = parcelRequire("gNF1f");
function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $gNF1f._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $gNF1f._)(o, minLen);
}

});
parcelRegister("gNF1f", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c3b10a83b523f372$export$71511d61b312f219; });
function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});




var $bB0zn = parcelRequire("bB0zn");

var $6QEWP = parcelRequire("6QEWP");
var $59bdea93f29f00f1$var$nav = {
    hamburger: function() {
        var hamburger = document.querySelector('.nav-toggle');
        if (!hamburger) return;
        var container = document.querySelector('body');
        hamburger.addEventListener('click', function() {
            hamburger.classList.toggle('nav--toggled');
            container.classList.toggle('nav--toggled');
        });
    }
};
var $59bdea93f29f00f1$export$2e2bcd8739ae039 = $59bdea93f29f00f1$var$nav;



var $kB67t = parcelRequire("kB67t");
var $368eda559bac203e$var$countUp = {
    parse: function(el) {
        var raw = el.textContent.trim();
        var match = raw.match(/([\D]*)([\d,.']+)([\D]*)/);
        if (!match) return null;
        var prefix = match[1];
        var numStr = match[2];
        var suffix = match[3];
        var separator = numStr.includes(',') ? ',' : numStr.includes('.') ? '.' : numStr.includes("'") ? "'" : '';
        var value = parseFloat(numStr.replace(/[,.']/g, ''));
        if (isNaN(value)) return null;
        return {
            prefix: prefix,
            suffix: suffix,
            separator: separator,
            value: value,
            originalNumStr: numStr
        };
    },
    format: function(value, separator, originalNumStr) {
        var parts = originalNumStr.split(/[.,]/);
        var lastPart = parts[parts.length - 1] || '';
        var decimals = parts.length > 1 && lastPart.length < 3 ? lastPart.length : 0;
        var fixed = value.toFixed(decimals);
        if (!separator) return fixed;
        var _fixed_split = (0, $kB67t._)(fixed.split('.'), 2), int = _fixed_split[0], dec = _fixed_split[1];
        var formatted = int.replace(/\B(?=(\d{3})+(?!\d))/g, separator);
        return dec !== undefined ? "".concat(formatted).concat(separator).concat(dec) : formatted;
    },
    easeOutQuart: function(t) {
        return 1 - Math.pow(1 - t, 4);
    },
    animate: function(el, parsed) {
        var _this = this;
        var duration = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1800;
        var prefix = parsed.prefix, suffix = parsed.suffix, separator = parsed.separator, value = parsed.value, originalNumStr = parsed.originalNumStr;
        var start = performance.now();
        var tick = function(now) {
            var elapsed = now - start;
            var progress = Math.min(elapsed / duration, 1);
            var current = value * _this.easeOutQuart(progress);
            el.textContent = prefix + _this.format(current, separator, originalNumStr) + suffix;
            if (progress < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
    },
    init: function() {
        var _this = this;
        var elements = document.querySelectorAll('.is-style-count-up');
        if (!elements.length) return;
        var observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (!entry.isIntersecting) return;
                var parsed = _this.parse(entry.target);
                if (parsed) _this.animate(entry.target, parsed);
                observer.unobserve(entry.target);
            });
        }, {
            threshold: 0.3
        });
        elements.forEach(function(el) {
            return observer.observe(el);
        });
    }
};
var $368eda559bac203e$export$2e2bcd8739ae039 = $368eda559bac203e$var$countUp;


var $847553d13b80c4b3$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function App() {
        (0, $bB0zn._)(this, App);
    }
    (0, $6QEWP._)(App, [
        {
            key: "initCore",
            value: function initCore() {
                (0, $59bdea93f29f00f1$export$2e2bcd8739ae039).hamburger();
                (0, $368eda559bac203e$export$2e2bcd8739ae039).init();
            }
        }
    ]);
    return App;
}();
function $847553d13b80c4b3$var$LoadApp() {
    var app = new $847553d13b80c4b3$export$2e2bcd8739ae039();
    app.initCore();
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', $847553d13b80c4b3$var$LoadApp);
else $847553d13b80c4b3$var$LoadApp();

})();
//# sourceMappingURL=_app.js.map
